export default "__VITE_ASSET__DqaUa4AO__"